import axiosInstance from "../config/AxiosConfig";

export const videoRepository = {
  getVideo: async () => {
    return await axiosInstance.get("/videos/");
  },
  saveVideo: async (data) => {
    return await axiosInstance.post("/videos", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
